import {
  SLIDABLE_PAGINATED_CLEAN_STATE,
  SLIDABLE_PAGINATED_RELOAD,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE,
  SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS,
} from '@Pages/RetroSynthesis/components/RsSlidablePaginated/constants';

export const loadItems = (params, loadItemsAsync) => async (dispatch) => {
  dispatch({ type: SLIDABLE_PAGINATED_SET_LOAD_ITEMS });
  try {
    const result = await loadItemsAsync(params);
    dispatch({ type: SLIDABLE_PAGINATED_SET_LOAD_ITEMS_SUCCESS, payload: { result, params } });
  } catch (error) {
    dispatch({ type: SLIDABLE_PAGINATED_SET_LOAD_ITEMS_FAILURE, payload: error });
  }
};

export const forceReload = (newSelectedItem) => ({ type: SLIDABLE_PAGINATED_RELOAD, payload: newSelectedItem });

export const clearState = () => ({ type: SLIDABLE_PAGINATED_CLEAN_STATE });
